import React, {useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import EditableText from '#components/a/form/EditableText'

function NachweisDetailAbteilungInput({
  setErrorMessage,
  onAbteilungNameChange,
  abteilungsname,
  suppressEmptyAbteilungError,
}) {
  const isStringEmpty = input => !input || input.trim() === ''
  const [abteilungInput, setAbteilungInput] = useState(abteilungsname || '')

  const handleBlur = newInput => {
    if (isStringEmpty(newInput)) {
      if (!isStringEmpty(abteilungsname)) {
        setAbteilungInput(abteilungsname)
      } else if (!suppressEmptyAbteilungError) {
        setErrorMessage(i18n.t('ausbildungsnachweis_abteilung_empty'))
      }
    } else {
      onAbteilungNameChange(newInput, isStringEmpty(newInput))
    }
  }

  const handleInput = newInput => {
    const isEmpty = isStringEmpty(newInput)
    if (!isEmpty) {
      setErrorMessage(undefined)
    }
    setAbteilungInput(newInput)
    onAbteilungNameChange(newInput, isStringEmpty(newInput))
  }

  const isNewOrOldAbteilungsnameValid = value => !isStringEmpty(value) || !isStringEmpty(abteilungsname)

  return (
    <div data-testid="nachweisheader-abteilungsname">
      <EditableText
        placeholder="Hier Abteilung eintragen"
        value={abteilungInput}
        onBlur={handleBlur}
        onChange={handleInput}
        validateInput={isNewOrOldAbteilungsnameValid}
      />
    </div>
  )
}

NachweisDetailAbteilungInput.propTypes = {
  setErrorMessage: PropTypes.func,
  onAbteilungNameChange: PropTypes.func,
  abteilungsname: PropTypes.string,
  suppressEmptyAbteilungError: PropTypes.bool,
}

export default NachweisDetailAbteilungInput
